"use client";

import { useState } from "react";
import { Icon } from "@/lib/icons";

export interface Faq {
  q: string;
  a: string;
}

export function FaqSection({ faqs, heading = "Frequently Asked Questions" }: { faqs: Faq[]; heading?: string }) {
  const [open, setOpen] = useState<number | null>(null);

  return (
    <section className="mx-auto mt-16 max-w-3xl px-4 sm:px-6">
      <h2 className="text-center text-2xl font-bold text-slate-900 sm:text-3xl">
        {heading}
      </h2>
      <div className="mt-8 space-y-3">
        {faqs.map((faq, i) => {
          const isOpen = open === i;
          return (
            <div
              key={faq.q}
              className="rounded-xl border border-slate-200 bg-white"
            >
              <button
                type="button"
                onClick={() => setOpen(isOpen ? null : i)}
                aria-expanded={isOpen}
                className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left font-medium text-slate-900"
              >
                {faq.q}
                <Icon
                  name="chevronDown"
                  className={`h-5 w-5 shrink-0 text-slate-400 transition-transform ${
                    isOpen ? "rotate-180" : ""
                  }`}
                />
              </button>
              {isOpen && (
                <div className="px-5 pb-5 text-sm leading-relaxed text-slate-600">
                  {faq.a}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}